import React from 'react';
import { useNavigate } from 'react-router-dom';
const WireframeServicesPage = () => {
  const navigate = useNavigate();
  return <div className="w-full bg-white p-3 font-mono text-[11px]" data-id="element-360">
      {/* Wireframe Header */}
      <header className="border border-dashed border-gray-400 p-2 mb-4" data-id="element-361">
        <div className="flex justify-between items-center" data-id="element-362">
          <div className="bg-gray-300 h-6 w-20 flex items-center justify-center text-[10px] text-gray-600" data-id="element-363">
            LOGO
          </div>
          <div className="flex gap-2" data-id="element-364">
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-365">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-366">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-367">
              Nav
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-3xl mx-auto" data-id="element-368">
        <div className="bg-gray-300 h-7 w-32 mb-4 flex items-center px-2 text-[11px] text-gray-600" data-id="element-369">
          H1: Services
        </div>

        {/* Search & Filter */}
        <div className="border border-dashed border-gray-400 p-3 mb-4" data-id="element-370">
          <div className="border border-gray-400 h-8 mb-3 flex items-center px-2 text-[10px] text-gray-500" data-id="element-371">
            [Search Input] 🔍
          </div>
          <div className="flex gap-1.5 flex-wrap" data-id="element-372">
            <div className="bg-gray-400 text-white h-6 px-3 flex items-center text-[10px]" data-id="element-373">
              All
            </div>
            <div className="bg-gray-200 h-6 px-3 flex items-center text-[10px] text-gray-600" data-id="element-374">
              Category
            </div>
            <div className="bg-gray-200 h-6 px-3 flex items-center text-[10px] text-gray-600" data-id="element-375">
              Category
            </div>
            <div className="bg-gray-200 h-6 px-3 flex items-center text-[10px] text-gray-600" data-id="element-376">
              Category
            </div>
          </div>
        </div>

        {/* Service Cards */}
        <div className="space-y-3" data-id="element-377">
          {[1, 2, 3].map(item => <div key={item} className="border border-dashed border-gray-400 p-3" data-id="element-378">
              <div className="flex gap-3" data-id="element-379">
                <div className="w-20 h-16 bg-gray-200 border border-dashed border-gray-400 flex items-center justify-center flex-shrink-0" data-id="element-380">
                  <span className="text-[9px] text-gray-500" data-id="element-381">Image</span>
                </div>
                <div className="flex-1 space-y-1.5" data-id="element-382">
                  <div className="bg-gray-300 h-5 w-32 flex items-center px-2 text-[10px] text-gray-600" data-id="element-383">
                    Service Name
                  </div>
                  <div className="bg-gray-200 h-3.5 w-full flex items-center px-2 text-[9px] text-gray-500" data-id="element-384">
                    Description text...
                  </div>
                  <div className="flex justify-between items-center" data-id="element-385">
                    <div className="space-y-0.5" data-id="element-386">
                      <div className="bg-gray-300 h-4 w-12 flex items-center px-1 text-[9px] text-gray-600" data-id="element-387">
                        £XX
                      </div>
                      <div className="bg-gray-200 h-3 w-14 flex items-center px-1 text-[8px] text-gray-500" data-id="element-388">
                        XX mins
                      </div>
                    </div>
                    <div className="bg-gray-400 h-7 w-16 flex items-center justify-center text-[10px] text-white" data-id="element-389">
                      Select
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {/* Annotation */}
      <div className="text-[9px] text-gray-400 text-center mt-4 mb-3" data-id="element-390">
        Wireframe v1.0 — Services List
      </div>

      {/* Navigation */}
      <div className="flex justify-center gap-2" data-id="element-391">
        <button onClick={() => navigate('/wireframe')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-392">
          ← Home
        </button>
        <button onClick={() => navigate('/wireframe/booking')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-393">
          → Booking
        </button>
      </div>
    </div>;
};
export default WireframeServicesPage;